import React from 'react';
import classnames from 'classnames';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IColorCfg {
  bgColor: string;
  textColor: string;
}

interface IPriorityTagProps extends IBaseProps {
  // 1、2、3分别对应高、中、低
  value?: '1' | '2' | '3' | (string & {});
}

const PRIORITY_NAMES: Record<string, string> = {
  '1': 'High',
  '2': 'Medium',
  '3': 'Low',
};

const PRIORITY_COLOR_CFGS: Record<string, IColorCfg> = {
  '1': {
    bgColor: 'rgba(239, 88, 88, 0.12)',
    textColor: '#EF5858',
  },
  '2': {
    bgColor: 'rgba(237, 165, 58, 0.12)',
    textColor: '#EDA53A',
  },
  '3': {
    bgColor: 'rgba(106, 109, 126, 0.12)',
    textColor: '#6A6D7E',
  },
};

const PriorityTag: React.FC<IPriorityTagProps> = (props) => {
  const { style, className, value = '' } = props;
  const name = PRIORITY_NAMES[value] || '';
  const colorCfg = PRIORITY_COLOR_CFGS[value] || {};
  return (
    <>
      {!name && '-'}
      {!!name && (
        <div
          style={{ ...style, backgroundColor: colorCfg?.bgColor, color: colorCfg?.textColor }}
          className={classnames('dbg-priority-tag', className)}
        >
          {name}
        </div>
      )}
    </>
  );
};

export default PriorityTag;
